
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concepts-overview/[id]",
      function () {
        return require("private-next-pages/concepts-overview/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concepts-overview/[id]"])
      });
    }
  